'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
var API_BASE_URL = exports.API_BASE_URL = 'https://api.candymemory.com/v1';
var API_LEVELS = exports.API_LEVELS = API_BASE_URL + '/levels'; // 客户等级
var API_ORDERS = exports.API_ORDERS = API_BASE_URL + '/orders'; // 订单
var API_PRODUCTS = exports.API_PRODUCTS = API_BASE_URL + '/products'; // 产品
var API_TEMPLATES = exports.API_TEMPLATES = API_BASE_URL + '/templates'; // 模版
var API_FINANCES = exports.API_FINANCES = API_BASE_URL + '/payments'; // 交易明细
var API_INOUT = exports.API_INOUT = API_BASE_URL + '/payments/stats'; // 收支统计
var API_USERS = exports.API_USERS = API_BASE_URL + '/users'; // 用户
var API_SHIPPING_TEMPLATES = exports.API_SHIPPING_TEMPLATES = API_BASE_URL + '/shipping_templates'; // 运费模版
var API_PICKUP_STATIONS = exports.API_PICKUP_STATIONS = API_BASE_URL + '/pickup_stations'; // 自提点
var API_UPLOAD_SIGN = exports.API_UPLOAD_SIGN = API_BASE_URL + '/uploads/sign'; // 上传图片签名
var API_UPLOADS = exports.API_UPLOADS = API_BASE_URL + '/uploads'; // 获取媒体库图片列表
var API_ENDPOINTS = exports.API_ENDPOINTS = {
    productTypes: API_BASE_URL + '/product_types',
    orders: API_BASE_URL + '/orders',
    couriers: API_BASE_URL + '/express_carriers',
    packages: API_BASE_URL + '/packages',
    refunds: API_BASE_URL + '/payments/refunds',
    users: API_BASE_URL + '/users',
    coupons: API_BASE_URL + '/coupons',
    home: API_BASE_URL + '/config'
};
var API_AUTH = exports.API_AUTH = {
    signin: API_BASE_URL + '/login',
    signup: API_BASE_URL + '/login',
    captcha: API_BASE_URL + '/login'

    /**
     * 默认的分页器设置
     * @type {Object}
     */
};var PaginationConfig = exports.PaginationConfig = {
    defaultCurrent: 1,
    defaultPageSize: 10
    // onChange: (current) => {
    //     console.log(current);
    // },
    // showSizeChanger: true,
    // pageSizeOptions: ['2', '5', '10', '20', '40'],
    // onShowSizeChange: (current, pageSize) => {
    //     console.log(current, pageSize);
    // },
    // showQuickJumper: true
};

/**
 * 财务交易类型
 */
var FINANCE_TYPES = exports.FINANCE_TYPES = ['充值', '支付', '退款', '扣款'];

/**
 * 客户状态类型
 */
var USER_STATUS = exports.USER_STATUS = ['禁用', '激活'];

/**
 * 产品类型
 */
var PRODUCT_TYPES = exports.PRODUCT_TYPES = ['照片冲洗', 'Lomo卡', '照片书', '台历', '挂历', '相框', '照片墙', '手机壳'];

var PRODUCT_STATUS = exports.PRODUCT_STATUS = [{
    id: 0,
    name: '下架'
}, {
    id: 1,
    name: '上架'
}];

var ORDER_STATUS = exports.ORDER_STATUS = ['已取消', '待支付', '待上传', '待生产', '待发货', '待收货', '已完成'];

/**
 * 优惠券状态码
 */

var COUPON_STATUS = exports.COUPON_STATUS = ['待激活', '待使用', '已使用'];

//生成二维码时的url
var API_H5_BASE_URL = exports.API_H5_BASE_URL = 'https://h5.candymemory.com/pay.html';


//////////////////
// WEBPACK FOOTER
// ./src/js/constants.js
// module id = 867
// module chunks = 0